export const SET_SELECTED_MONTH = "SET_SELECTED_MONTH";
export const SET_SELECTED_TENANT = "SET_SELECTED_TENANT";
